import SupplierManager from "@/components/SupplierManager";
import { Building2 } from "lucide-react";

export default function Suppliers() {
  return (
    <div className="space-y-5 fade-in" data-testid="suppliers-page">
      <div className="flex items-center gap-2">
        <Building2 className="h-5 w-5 text-brand-green" />
        <div>
          <p className="overline">Satın Alma & Tedarik</p>
          <h1 className="font-heading text-2xl font-bold text-slate-900">Tedarikçiler</h1>
        </div>
      </div>
      <p className="text-sm text-slate-500">
        Tedarikçi firma/kişi kartları — iletişim, adres ve tedarik kategorileri. Satın alma siparişlerinde buradaki tedarikçiler seçilir.
      </p>
      <SupplierManager />
    </div>
  );
}
